import React from 'react';
import PropTypes from 'prop-types';
import { MarkdownText } from '../../components';

const SectionTextMaybe = ({
  text = null,
  heading = null,
  showAsIngress = false,
  enableMarkdown = true,
  markdownOptions = {},
}) => {
  return (
    <MarkdownText
      text={text}
      heading={heading}
      showAsIngress={showAsIngress}
      enableMarkdown={enableMarkdown}
      markdownOptions={markdownOptions}
      headingLevel="h2"
    />
  );
};

SectionTextMaybe.propTypes = {
  text: PropTypes.string,
  heading: PropTypes.string,
  showAsIngress: PropTypes.bool,
  enableMarkdown: PropTypes.bool,
  markdownOptions: PropTypes.shape({
    components: PropTypes.object,
  }),
};

export default SectionTextMaybe;
